import React, { useEffect, useState } from 'react';
import useShopifyInstall from 'hooks/useShopifyInstall';
import LoadingPage from 'auth/LoadingPage';
import ShopifyDriver from './ShopifyDriver';
import AppContainer from 'containers/AppContainer';

interface ShopifyAppBridgeWrapperProps {
  children: React.ReactNode;
}

export const ShopifyAppBridgeWrapper: React.FC<
  ShopifyAppBridgeWrapperProps
> = ({ children }) => {
  const [redirecting, setRedirecting] = useState(true);
  const {
    authorizationUrl,
    apiKey,
    isLoading: isLoadingAuthorizationUrl,
    authorizationNeeded,
  } = useShopifyInstall();

  // Load the host from the window URLs (note we need to use state because after the first redirect
  // it will be lost)
  const [hostBase64, setHostBase64] = useState<string | undefined>();
  const [host, setHost] = useState<string | undefined>();

  useEffect(() => {
    const tmp = new URLSearchParams(window.location.search).get('host');
    if (tmp) {
      setHostBase64(tmp);
      setHost(atob(tmp));
    } else {
      console.error('No host param found on URL');
    }
  }, []);

  useEffect(() => {
    if (authorizationNeeded && authorizationUrl) {
      window.location.assign(authorizationUrl);
    } else {
      setRedirecting(false);
    }
  }, [authorizationUrl, authorizationNeeded]);

  if (isLoadingAuthorizationUrl || redirecting || !host || !hostBase64) {
    return <LoadingPage />;
  } else {
    return (
      <ShopifyDriver apiKey={apiKey} host={host}>
        <AppContainer>{children}</AppContainer>
      </ShopifyDriver>
    );
  }
};
